import { Div, P } from '@kizi/core-components';
import { IconV2 as Icon } from '@kizi/shared-components';
import React from 'react';

export interface TileRadioLabelProps {
  direction: 'horizontal' | 'vertical';
  text: string;
  subText?: string;
  icon?: string;
}

export const TileRadioLabel: React.FC<TileRadioLabelProps> = ({
  direction,
  text,
  subText,
  icon,
}): JSX.Element => {
  const isVertical = direction === 'vertical';

  return (
    <Div
      display="flex"
      alignItems="center"
      flexDirection={isVertical ? 'column' : 'row'}
    >
      {icon && (
        <Icon
          name={icon}
          width={isVertical ? 72 : 20}
          height={isVertical ? 72 : 20}
          css={isVertical ? { marginBottom: 2 } : { marginRight: 2 }}
        />
      )}
      <P
        variant="bodyImportant"
        css={isVertical ? { marginBottom: 1 } : { marginRight: 1 }}
      >
        {text}
      </P>
      {subText && (
        <P variant="captionRegular" color="#727888">
          {subText}
        </P>
      )}
    </Div>
  );
};
